import { Link } from 'react-router';
import CoverPlaceholder from './CoverPlaceholder.jsx';
import { formatMoney } from '../../lib/money.js';

/**
 * One catalog entry. No card, no shadow, no rounded corner — the cover is the
 * object and the metadata sits beneath it like a shelf label. The only motion is
 * the cover lifting off the page.
 */
export default function BookTile({ book, kind, index = 0 }) {
  const href = `/${kind === 'secondhand' ? 'secondhand' : 'new'}/${book.slug}`;
  const authorName = Array.isArray(book.authors) ? book.authors.join(', ') : book.author || book.authors;
  const publisherName = book.publisher?.name || book.publisherName || book.publisher;
  const coverUrl = book.cover?.url || book.coverUrl;

  return (
    <article>
      <Link to={href} className="group block no-underline">
        <div className="cover-lift">
          {coverUrl ? (
            <div className="border-rule/60 relative aspect-2/3 w-full overflow-hidden border bg-paper-deep">
              <img
                src={coverUrl}
                alt={book.title}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
              />
            </div>
          ) : (
            <CoverPlaceholder title={book.title} author={authorName} tone={index} />
          )}
        </div>

        <h3
          className="font-display mt-3 sm:mt-4 text-base sm:text-lg leading-snug text-ink group-hover:text-stamp transition-colors duration-150 line-clamp-2"
          style={{ fontVariationSettings: "'SOFT' 20, 'WONK' 1, 'opsz' 40" }}
        >
          {book.title}
        </h3>
        <p className="text-ink-60 mt-0.5 text-xs sm:text-sm truncate">{authorName}</p>
      </Link>

      <p className="mt-2.5 sm:mt-3 flex flex-wrap items-baseline justify-between gap-x-2 gap-y-1">
        {kind === 'secondhand' ? (
          <span className="label border border-rule px-1.5 py-0.5 text-[0.625rem] text-ink-80 tracking-wider">
            {book.condition || 'Graded'}
          </span>
        ) : (
          <span className="label text-ink-60 truncate max-w-[95px] sm:max-w-none text-[0.6875rem]">
            {publisherName}
          </span>
        )}
        <span className="label text-stamp font-bold ml-auto tabular-nums text-xs sm:text-sm">
          {formatMoney(book.priceMinor)}
        </span>
      </p>
    </article>
  );
}
